export default [
  'BEIJING',
  'SHANGHAI',
  'GUANGDONG',
  'ZHEJIANG',
  'TIANJIN',
  'JIANGSU',
  'SICHUAN',
  'FUJIAN',
  'HEBEI',
  'LIAONING',
  'HUBEI',
  'CHONGQING',
  'NEI MONGOL',
  'JILIN',
  'HEILONGJIANG',
  'SHANXI',
  'ANHUI',
  'JIANGXI',
  'SHANDONG',
  'HENAN',
  'HUNAN',
  'GUANGXI',
  'HAINAN',
  'GUIZHOU',
  'YUNNAN',
  'SHAANXI',
  'GANSU',
  'QINGHAI',
  'NINGXIA',
  'XIZANG',
  'XINJIANG',
  'OTHER',
];



// WEBPACK FOOTER //
// ./src/constants/provinces-pinyin-constants.js